import isWithinInterval from "date-fns/isWithinInterval";
import { BannerConfig } from "./DrxBanner.config";
import { Brand } from "./types";

export function isBannerActive(): boolean {
  return (
    isWithinInterval(new Date(), { start: BannerConfig.startDate, end: BannerConfig.endDate }) &&
    isBannerActiveForBrand(BannerConfig.activeForBrands)
  );
}

function isBannerActiveForBrand(brands: Array<Brand>): boolean {
  return !!process.env.APP_THEME && brands.includes(process.env.APP_THEME as Brand);
}

export const { data } = BannerConfig;

export { default } from "./DrxBanner.vue";
